module.exports = __webpack_public_path__ + "static/img/3daduhe.0d26d738.jpg";